// extracted by mini-css-extract-plugin
module.exports = {"guaranteePoints":"GuaranteePoints_guaranteePoints__L_W4D","verticalDivider":"GuaranteePoints_verticalDivider__H6JhX","horizontalDivider":"GuaranteePoints_horizontalDivider__QYVBQ"};